import { useCallback, useState } from 'react';

import { FilterOperators } from '@/components/Filter/types';
import useListActions from '@/hooks/useList/useListActions';

import { NewFilterOption, UseFilterListActionsProps } from '../types';

export default function useFilterListActions({
  initialSelectedOptions,
  keyExtractor,
  showActionButtons,
  onChange,
  initialSelectedOperator,
}: UseFilterListActionsProps) {
  const [currSelectedOperator, setSelectedOperator] = useState<FilterOperators | undefined>(
    initialSelectedOperator,
  );

  const onFilterChange = useCallback(
    (val: NewFilterOption[]) => {
      onChange?.(val, currSelectedOperator);
    },
    [onChange, currSelectedOperator],
  );

  const [
    selectedOptions,
    { toggle: toggleOption, addMultiple, removeMultiple, removeAll, addSingle },
  ] = useListActions({
    selectedItems: initialSelectedOptions,
    keyExtractor,
    updateOnAction: !showActionButtons,
    onChange: onFilterChange,
  });

  return {
    operatorsActions: {
      selectedOperator: currSelectedOperator,
      methods: {
        setSelectedOperator,
      },
    },
    optionsActions: {
      selectedOptions,
      methods: {
        toggleOption,
        addMultiple,
        removeMultiple,
        removeAll,
        addSingle,
      },
    },
  };
}
